import React, { useEffect, useRef, useState } from 'react';
import UncontrolledTooltip from '@minecraft.uncontrolled-tooltip';

type Props = {
  children: React.ReactNode;
  id: string;
  tooltipPlacement: 'right' | 'left' | 'top' | 'bottom';
  tooltipContent: React.ReactNode;
  className?: string;
  StyledTooltipComponent?: React.ReactNode;
  autohide?: boolean;
  /**
    @forAgGrid {boolean: optional} field used to avoid problems with rendering tooltips under AgGridColumn
   */
  forAgGrid?: boolean;
};

const ItemWithTooltip: React.FC<Props> = ({
  id,
  children,
  tooltipPlacement,
  tooltipContent,
  className = '',
  StyledTooltipComponent = null,
  autohide = true,
  forAgGrid = false,
}) => {
  const linkRef = useRef();
  const [isReadyTooltip, setIsReadyTooltip] = useState(false);
  /**
   *  When forAgGrid = true we should rerender component to get proper target.
   *  Only for components which used under AgGridColumn.
   */
  useEffect(() => {
    if (linkRef?.current && !isReadyTooltip && forAgGrid) {
      setIsReadyTooltip(true);
    }
  }, [linkRef?.current, forAgGrid]);
  const TooltipComponent = (StyledTooltipComponent || UncontrolledTooltip) as React.ElementType;
  return (
    <>
      <span id={id} className={className} data-testid="icon-with-tooltip" ref={linkRef}>
        {children}
      </span>
      {(!forAgGrid || isReadyTooltip) && (
        <TooltipComponent placement={tooltipPlacement} target={linkRef?.current || id} autohide={autohide}>
          {tooltipContent}
        </TooltipComponent>
      )}
    </>
  );
};

export default ItemWithTooltip;
